import { Route } from '@angular/router';

import { ClaimDetailsComponent } from './claim-details/claim-details.component';
import { EntryComponent } from './entry/entry.component';
import { MaintenanceComponent } from './shared/errors/error-pages/maintenance/maintenance.component';
import { NotFoundComponent } from './shared/errors/error-pages/not-found/not-found.component';

/**
 * Routes for the app.
 */
export const ROUTES: Route[] = [
	{
		path: 'track-a-claim',
		component: EntryComponent,
		data: { animation: 'EntryPage' }
	},
	{
		path: 'claim-details',
		component: ClaimDetailsComponent,
		data: { animation: 'ClaimDetailsPage' }
	},
	{ path: '', redirectTo: '/track-a-claim', pathMatch: 'full' },
	{ path: 'maintenance', component: MaintenanceComponent, data: { animation: 'MaintenancePage' } },
	{
		path: '**',
		component: NotFoundComponent,
		data: { animation: 'NotFoundPage' }
	}
];
